module.exports = __webpack_public_path__ + "img/Slice4.97483e43.png";